export default __webpack_public_path__ + "static/media/pinPoint.8a6a2c7c.png";